import React, { ReactNode } from 'react';

import styles from './styles.module.scss';

export interface NoraCaptionProps {
  children?: ReactNode;
}

export const NoraCaption = ({ children }: NoraCaptionProps) => (
  <div className={styles.NoraCaption}>
    <h3>{children}</h3>
  </div>
);
